/*
 * 应用布尔值修改弹框组件
 * zxw
 * 创建时间 2026-04-20
*/

import CNF from '../../../incs/Config.js';
import { AddRequestHeaders } from '../../../incs/FunHelper.js';
import { useState, useEffect } from 'react';
import $ from 'jquery';
import {
    ConfigProvider,
    message,
    Input,
    Modal,
    Typography,
} from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';

const { TextArea } = Input;
const { Text } = Typography;

/**
 * 信息提示框组件
 * 主要针对公开、发行等操作（PATCH）
 * @param {*} props 
 * @returns 
 */
const AppinfoBooleanPatchModel = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [description, setDescription] = useState('');

    useEffect(() => {
        setOpen(props.open);
    }, [props]);

    /**
     * 取消
     */
    const cancel = () => {
        setLoading(false);
        setDescription('');
        setOpen(false);
    }

    const getNoteByAction = (action) => {
        switch (action) {
            case '公开应用':
                return '注意：应用公开后将在团队内部可见。';
            case '取消公开':
                return '注意：应用取消公开后将在团队内部不可见。';
            case '发行应用':
                return '注意：应用发行后将在应用市场可见。';
            case '取消发行':
                return '注意：应用取消发行后将在应用市场不可见。';
            default:
                return '';
        }
    }

    /**
     *  处理
     *  @param {*} record 
     *  @param {*} action 
     */
    const ok = () => {
        setLoading(true);
        $.ajax({
            url: `${CNF.api}app/infos/${props.record.key}`,
            headers: AddRequestHeaders(),
            type: 'PATCH',
            dataType: 'JSON',
            data: JSON.stringify({
                ...props.params,
                description: description
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    props.isRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }

        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        }).always(function () {
            setTimeout(function () {
                cancel();
            }, CNF.messageDuration * 1000);
        })
    }

    return (
        <ConfigProvider
            variant='outlined'
            theme={{
                token: {
                    colorPrimary: global.THEMECOLOR ? global.THEMECOLOR : CNF.themeColors[0],
                },
            }}
        >
            {contextHolder}
            <Modal
                title={<><ExclamationCircleFilled style={{ color: global.THEMECOLOR ? global.THEMECOLOR : CNF.themeColors[0] }} /> {props?.action}</>}
                closeIcon={false}
                open={open}
                onOk={ok}
                onCancel={cancel}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: description ? false : true, loading }}
            >
                <div>
                    <p style={{ marginTop: 0 }}>
                        <Text>考虑清楚了？确定要 <Text type='warning' strong>{props?.action.replace('应用', '')}</Text> 该<Text strong>“{props.record.app_name}”</Text>应用？</Text>
                        <br />
                        <Text type='warning'>{getNoteByAction(props?.action)}</Text>
                    </p>
                    <TextArea
                        placeholder='请填写备注'
                        autoSize={{ minRows: 3, maxRows: 5 }}
                        onChange={(e) => { setDescription(e.target.value) }}
                        value={description}
                        disabled={loading}
                    />
                </div>
            </Modal >
        </ConfigProvider >
    );
}

export default AppinfoBooleanPatchModel;